module.exports = "./img/290cbd2d79597e785aa2e9069a394e78.png";